var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlendedLearningNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.66 62.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.84,52.4c8.14-4.71,13.61-13.51,13.61-23.58s-5.47-18.88-13.61-23.58c-8.14,4.71-13.61,13.51-13.61,23.58s5.47,18.88,13.61,23.58Z",
    fill: "#f4a100",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7,53.06c8.36-4.84,13.99-13.88,13.99-24.23s-5.62-19.39-13.99-24.23c4.11-2.38,8.89-3.74,13.99-3.74,15.45,0,27.97,12.52,27.97,27.97s-12.52,27.97-27.97,27.97c-5.09,0-9.87-1.36-13.99-3.74Z",
    fill: "#0061f2",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.97,4.6c-8.36,4.84-13.99,13.88-13.99,24.23s5.62,19.39,13.99,24.23c-4.11,2.38-8.89,3.74-13.99,3.74C12.54,56.8.02,44.28.02,28.83c0-15.45,12.52-27.97,27.97-27.97,5.09,0,9.87,1.36,13.99,3.74Z",
    fill: "#f76400",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlendedLearningNoText);
export default __webpack_public_path__ + "static/media/blended-learning-no-text.6bc92ddc3d175c876531ba4ab351318d.svg";
export { ForwardRef as ReactComponent };